import type { nav as enNav } from "../en/nav";

export const nav: typeof enNav = {
  menu: {
    home: "Home",
    guide: "Guida",
    quotes: "Preventivi",
    poInbox: "Inbox PO",
    companies: "Aziende",
    priceLists: "Listini prezzi",
    aiAssistant: "Assistente IA",
    settings: "Impostazioni",
    sendFeedback: "Invia feedback",
  },
  errorBoundary: {
    notFoundHeadline: "Pagina non trovata",
    sessionExpiredHeadline: "Sessione scaduta",
    genericHeadline: "Qualcosa è andato storto",
    notFoundBody: "La pagina che stavi cercando non esiste oppure non hai accesso ad essa.",
    sessionExpiredBody: "Ricarica la pagina per accedere di nuovo.",
    genericBody: "Riprova tra qualche istante oppure contatta l'assistenza se il problema persiste.",
    backToDashboard: "Torna alla dashboard",
    quotes: "Preventivi",
    companies: "Aziende",
  },
};
